import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const EnrolledCreditsHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='Enrolled credits'>
    Credits you're taking for current term
  </HelpModal>